/* eslint-disable no-underscore-dangle */
import { hydrateRoot } from "react-dom/client";
import { loadableReady } from "@loadable/component";
import App from "../app/index";

const { contentData, storeData, countPerPage, categoryId } =
  window.asos.ugc.state;
delete window.asos.ugc.state;

const start = async () => {
  loadableReady(() => {
    hydrateRoot(
      document.getElementById("react-root"),
      <App
        contentData={contentData}
        storeData={storeData}
        countPerPage={countPerPage}
        categoryId={categoryId}
      />
    );
  });
};

start();
